<template>
  <div class="mx-3">
    <strong class="d-block py-2 my-3">{{ question.text }}</strong>
    <div class="mb-4">
      <div
        class="d-block"
        v-for="(answer, index) of question.answer_options"
        :key="answer.id"
      >
        <Checkbox
          :value="answers[index] === 'yes' ? true : false"
          @change="changed(index)()"
        ></Checkbox>
        <!-- <input
          type="checkbox"
          v-model="answers[index]"
          true-value="yes"
          false-value="no"
        /> -->
        <label class="pointer" @click="changed(index)()">
          {{ answer.label }}
        </label>
      </div>
    </div>
    <button
      type="button"
      @click.stop="submit"
      class="btn btn-block btn-primary"
    >
      {{ $t('next') }} <double-arrow-icon></double-arrow-icon>
    </button>
  </div>
</template>
<script>
import DoubleArrowIcon from '@/components/Icons/DoubleArrow'
import Checkbox from '@/components/Form/Checkbox'
export default {
  components: {
    DoubleArrowIcon,
    Checkbox
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    nextCallback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      answers: []
    }
  },
  methods: {
    submit () {
      const answers = []
      for (const i in this.answers) {
        if (this.answers[i] === 'yes') {
          answers.push(this.question.answer_options[i].id)
        }
      }
      this.nextCallback(answers)
    },
    changed (index) {
      return () => {
        if (this.answers[index] === 'yes') {
          this.$set(this.answers, index, 'no')
        } else {
          this.$set(this.answers, index, 'yes')
        }
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "next": "განაგრძე"
  },
  "en": {
    "next": "Next"
  }
}
</i18n>
